import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

const Input = ({ id, label, ...p }) => (
  <div><label htmlFor={id} className="block text-xs font-semibold text-[#52706D] mb-1.5">{label}</label><input id={id} className="field-vp" required {...p} /></div>
);

export default function Login() {
  const [sp] = useSearchParams();
  const [tab, setTab] = useState(sp.get("tab") === "register" ? "register" : "login");
  const [v, setV] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = tab === "login" ? await login(v.email, v.password) : await register(v);
      const next = sp.get("next");
      nav(next && next.startsWith("/") ? next : u.platform_role === "SUPER_ADMIN" ? "/admin" : "/klinik/dashboard");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-vp py-14 flex justify-center" data-testid="login-page">
      <div className="w-full max-w-md card-vp p-8">
        <Logo />
        <div className="grid grid-cols-2 bg-[#E6F4EF] rounded-full p-1 mt-6" role="tablist">
          {[["login", "Log ind"], ["register", "Opret konto"]].map(([k, l]) => (
            <button key={k} role="tab" aria-selected={tab === k} onClick={() => { setTab(k); setError(""); }} data-testid={`auth-tab-${k}`}
              className={`h-9 rounded-full text-sm font-semibold transition-colors ${tab === k ? "bg-white text-[#153C3A] shadow-sm" : "text-[#52706D]"}`}>{l}</button>
          ))}
        </div>
        <p className="text-sm text-[#52706D] mt-4">{tab === "login" ? "Log ind som klinikbruger eller VetPris-administrator." : "Konti er til klinikpersonale. Efter oprettelse kan du anmode om ejerskab af din klinik – anmodningen godkendes af VetPris."}</p>
        <form onSubmit={submit} className="grid gap-4 mt-5" data-testid="auth-form">
          {tab === "register" && <Input id="name" label="Fulde navn" value={v.name} onChange={(e) => setV({ ...v, name: e.target.value })} data-testid="register-name-input" autoComplete="name" />}
          <Input id="email" label="E-mail" type="email" value={v.email} onChange={(e) => setV({ ...v, email: e.target.value })} data-testid="auth-email-input" autoComplete="email" />
          <Input id="password" label="Adgangskode" type="password" value={v.password} minLength={tab === "register" ? 10 : undefined}
            onChange={(e) => setV({ ...v, password: e.target.value })} data-testid="auth-password-input" autoComplete={tab === "login" ? "current-password" : "new-password"} />
          {tab === "register" && <p className="text-xs text-[#52706D] -mt-2">Mindst 10 tegn med både bogstaver og tal.</p>}
          {error && <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3" role="alert" data-testid="auth-error">{error}</p>}
          <button className="btn-primary w-full" disabled={busy} data-testid="auth-submit-button">{busy ? "Vent…" : tab === "login" ? "Log ind" : "Opret konto"}</button>
          {tab === "login" && <Link to="/glemt-adgangskode" className="text-sm text-[#087F72] hover:underline text-center" data-testid="forgot-password-link">Glemt adgangskode?</Link>}
        </form>
      </div>
    </div>
  );
}
